var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-card",
        [
          _vm._v(
            " 当前模式是: " +
              _vm._s(_vm.type === 1 ? "自动模式" : " 手动模式") +
              " "
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.switchMode } },
            [_vm._v(" 切换模式 ")]
          ),
          _vm.showAuto !== 3
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(3)
                    },
                  },
                },
                [_vm._v(" 查看实时通道数据 ")]
              )
            : _vm._e(),
          _vm.showAuto === 3 || _vm.showAuto === 0 || _vm.showAuto === 4
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(1)
                    },
                  },
                },
                [_vm._v(" 查看自动模式数据 ")]
              )
            : _vm._e(),
          _vm.showAuto === 3 ||
          (_vm.showAuto === 1 && _vm.type === 0) ||
          _vm.showAuto === 4
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(0)
                    },
                  },
                },
                [_vm._v(" 查看手动模式数据 ")]
              )
            : _vm._e(),
          _vm.showAuto !== 4
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.editManyWeightBotton,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showManyWeight(true)
                    },
                  },
                },
                [_vm._v(" 查看多套手动模式数据 ")]
              )
            : _vm._e(),
          _vm.type === 0 && _vm.showAuto !== 3
            ? _c(
                "el-dropdown",
                { staticClass: "dropdown", on: { command: _vm.addTable } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("common.AddChannel")) + " "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    _vm._l(_vm.methodList, function (item, index) {
                      return _c(
                        "el-dropdown-item",
                        { key: index, attrs: { command: item } },
                        [_vm._v(_vm._s(item) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { sm: 7, xs: 0 } },
        [
          _c(
            "el-card",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showAvailableChannlDialog },
                },
                [_vm._v(_vm._s(_vm.$t("common.AddAvailablechannel")))]
              ),
              _c("p", [_vm._v(_vm._s(_vm.$t("common.CurrentChannelConfig")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("common.Availablechannel")))]),
              _c(
                "draggable",
                {
                  attrs: { group: _vm.grouptableA },
                  on: { end: _vm.grouptableEnd },
                  model: {
                    value: _vm.channelsList,
                    callback: function ($$v) {
                      _vm.channelsList = $$v
                    },
                    expression: "channelsList",
                  },
                },
                _vm._l(_vm.channelsList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "channl" },
                    [
                      _c(
                        "el-tag",
                        {
                          staticStyle: { height: "150px" },
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.removeAvailableChannle(index)
                            },
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("common.Channel")) +
                                "： " +
                                _vm._s(item.channelStr)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("common.ChannelName")) +
                                "： " +
                                _vm._s(item.sign)
                            ),
                          ]),
                          _c("div", [_vm._v("payKey: " + _vm._s(item.payKey))]),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("common.Collectionbalance")) +
                                "： " +
                                _vm._s(item.maxCash) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { sm: 17, xs: 24 } },
        [
          (_vm.type === 0 && _vm.showAuto === 0) || _vm.showAuto === 4
            ? _c(
                "el-card",
                [
                  _vm.type === 0 && _vm.showAuto === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editWeightfn },
                        },
                        [_vm._v(" 表格修改完成 ")]
                      )
                    : _vm._e(),
                  _vm.type === 0 && _vm.showAuto === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.editManyWeightBotton,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showManyWeight(false)
                            },
                          },
                        },
                        [_vm._v(" 查看或修改多权重 ")]
                      )
                    : _vm._e(),
                  _vm.type === 0 && _vm.showAuto === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.editManyWeightBotton,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showMerchantChannel()
                            },
                          },
                        },
                        [_vm._v(" 查看或修改商户多权重 ")]
                      )
                    : _vm._e(),
                  _vm.showAuto === 4
                    ? _c(
                        "div",
                        [
                          !_vm.addHandWeight
                            ? _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.handWeightOptionOnce,
                                    callback: function ($$v) {
                                      _vm.handWeightOptionOnce = $$v
                                    },
                                    expression: "handWeightOptionOnce",
                                  },
                                },
                                _vm._l(
                                  _vm.handWeightOption,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          !_vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handWeightOptionSelect },
                                },
                                [_vm._v(" 查看 ")]
                              )
                            : _vm._e(),
                          !_vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.editWeightfn },
                                },
                                [_vm._v(" 修改方案 ")]
                              )
                            : _vm._e(),
                          !_vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editWeightfn(1)
                                    },
                                  },
                                },
                                [_vm._v(" 使用此方案 ")]
                              )
                            : _vm._e(),
                          !_vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addHandWeightOptiontPre },
                                },
                                [_vm._v(" 添加方案 ")]
                              )
                            : _vm._e(),
                          !_vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: { click: _vm.handWeightOptiondelete },
                                },
                                [_vm._v(" 删除此方案 ")]
                              )
                            : _vm._e(),
                          _vm.addHandWeight
                            ? _c("el-input", {
                                attrs: { placeholder: "请输入方案名称" },
                                model: {
                                  value: _vm.optionName,
                                  callback: function ($$v) {
                                    _vm.optionName = $$v
                                  },
                                  expression: "optionName",
                                },
                              })
                            : _vm._e(),
                          _vm.addHandWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editWeightfn()
                                    },
                                  },
                                },
                                [_vm._v(" 确认添加新方案 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.tableData, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "el-card",
                  [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.method)),
                    ]),
                    _vm.type === 0 && _vm.showAuto === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openSuccessRateDialog(item.method)
                              },
                            },
                          },
                          [_vm._v(" 修改自动模式下的成功率区间 ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.showAuto === 1
                  ? _c(
                      "el-table",
                      {
                        attrs: {
                          title: item.method,
                          data: item.list,
                          "span-method": _vm.arraySpanMethod,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "level",
                            prop: "level",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "权重百分比",
                            prop: "weight",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "实时通道",
                            prop: "channelStr",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "拉起百分比",
                            prop: "pullUpRate",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "分发百分比",
                            prop: "totalRate",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "回调成功率",
                            prop: "notifyRate",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showAuto === 0 || _vm.showAuto === 4
                  ? _c(
                      "draggable",
                      {
                        attrs: {
                          group: _vm.grouptable,
                          options: { handle: ".dd" },
                        },
                        model: {
                          value: item.list,
                          callback: function ($$v) {
                            _vm.$set(item, "list", $$v)
                          },
                          expression: "item.list",
                        },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              title: item.method,
                              "show-summary": "",
                              data: item.list,
                            },
                          },
                          [
                            _vm.showAuto === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "序号",
                                    prop: "number",
                                  },
                                })
                              : _vm._e(),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "通道名称",
                                prop: "channelStr",
                              },
                            }),
                            _c("el-table-column", {
                              key: _vm.tableKey,
                              attrs: {
                                align: "center",
                                label: "权重",
                                prop: "weight",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.$index +
                                                  item.method +
                                                  "weight" ===
                                                _vm.displayindex,
                                              expression:
                                                "\n                  scope.$index + item.method + 'weight' === displayindex\n                ",
                                            },
                                          ],
                                          on: {
                                            keydown: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.editWeightOnefn(
                                                index,
                                                scope.$index,
                                                _vm.weightNumber,
                                                1
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.editWeightOnefn(
                                                index,
                                                scope.$index,
                                                _vm.weightNumber,
                                                1
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.weightNumber,
                                            callback: function ($$v) {
                                              _vm.weightNumber = _vm._n($$v)
                                            },
                                            expression: "weightNumber",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.$index +
                                                    item.method +
                                                    "weight" !==
                                                  _vm.displayindex,
                                                expression:
                                                  "\n                  scope.$index + item.method + 'weight' !== displayindex\n                ",
                                              },
                                            ],
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                _vm.displayindex =
                                                  scope.$index +
                                                  item.method +
                                                  "weight"
                                                _vm.weightNumber =
                                                  scope.row.weight
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.weight) +
                                                "% "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "payKey",
                                prop: "payKey",
                              },
                            }),
                            _vm.showAuto === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "拉起成功率",
                                    prop: "pullUpRate",
                                  },
                                })
                              : _vm._e(),
                            _vm.showAuto === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "回调成功率",
                                    prop: "notifyRate",
                                  },
                                })
                              : _vm._e(),
                            _c("el-table-column", {
                              attrs: { label: "操作" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            circle: "",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteUnAutoChannl(
                                                item.method,
                                                scope.$index
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showAuto === 3
                  ? _c(
                      "el-table",
                      {
                        key: _vm.tableKey,
                        attrs: { title: item.method, data: item.list },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "通道名称",
                            prop: "ChannelStr",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "权重",
                            prop: "Weight",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(scope.row.Weight) + "% "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "PayInKey",
                            prop: "PayInKey",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "代收余额",
                            prop: "MaxPayInCash",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "修改成功率区间", visible: _vm.successRateVisible },
          on: {
            "update:visible": function ($event) {
              _vm.successRateVisible = $event
            },
            close: _vm.clearEditSuccessRate,
          },
        },
        [
          _c(
            "div",
            [
              _c("p", [_vm._v("可用通道")]),
              _c(
                "draggable",
                {
                  attrs: { group: _vm.grouptableA },
                  on: { end: _vm.groupSuccessRateEnd },
                  model: {
                    value: _vm.channelsList,
                    callback: function ($$v) {
                      _vm.channelsList = $$v
                    },
                    expression: "channelsList",
                  },
                },
                _vm._l(_vm.channelsList, function (item, index) {
                  return _c(
                    "el-tag",
                    { key: index, staticClass: "channlName" },
                    [_vm._v(_vm._s(item.channelStr) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.editOneSuccessRate, function (item, index) {
            return _c(
              "el-form",
              { key: index, attrs: { inline: true } },
              [
                index !== 0
                  ? _c("div", [_vm._v("---------------------")])
                  : _vm._e(),
                _c(
                  "draggable",
                  {
                    staticStyle: { "min-width": "100px" },
                    attrs: { group: _vm.groupA, options: { handle: ".dd" } },
                    model: {
                      value: item.channels,
                      callback: function ($$v) {
                        _vm.$set(item, "channels", $$v)
                      },
                      expression: "item.channels",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "最小成功率" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.min,
                            callback: function ($$v) {
                              _vm.$set(item, "min", _vm._n($$v))
                            },
                            expression: "item.min",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "最大成功率" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.max,
                            callback: function ($$v) {
                              _vm.$set(item, "max", _vm._n($$v))
                            },
                            expression: "item.max",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "权重" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.weight,
                            callback: function ($$v) {
                              _vm.$set(item, "weight", _vm._n($$v))
                            },
                            expression: "item.weight",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道：" } },
                      _vm._l(item.channels, function (item1, index1) {
                        return _c(
                          "el-tag",
                          {
                            key: index1,
                            staticClass: "channlName",
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.deleteAutoChannl(index, index1)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item1.channelStr) + " ")]
                        )
                      }),
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "删除" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            size: "mini",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteSuccessRate(item, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c("el-button", {
            attrs: { type: "primary", icon: "el-icon-plus", size: "mini" },
            on: {
              click: function ($event) {
                return _vm.addSuccessRate()
              },
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.successRateVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addLastSuccessRate },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.manyWeightDialog ? "多方案权重区间" : "修改权重区间",
            width: "90%",
            visible: _vm.manyWeightVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.manyWeightVisible = $event
            },
            close: _vm.clearEditSuccessRate,
          },
        },
        [
          _vm.manyWeightDialog
            ? _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  !_vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "方案名称：" } },
                        [
                          !_vm.addHandWeight
                            ? _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.handWeightOptionSelect },
                                  model: {
                                    value: _vm.handWeightOptionOnce,
                                    callback: function ($$v) {
                                      _vm.handWeightOptionOnce = $$v
                                    },
                                    expression: "handWeightOptionOnce",
                                  },
                                },
                                _vm._l(
                                  _vm.handWeightOption,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addNewManyWeight },
                            },
                            [_vm._v("添加方案")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.addLastLimitRate(false)
                                },
                              },
                            },
                            [_vm._v("确认修改此方案")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.handWeightOptiondelete },
                            },
                            [_vm._v("删除此方案")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "新方案名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.newSchemeName,
                              callback: function ($$v) {
                                _vm.newSchemeName = $$v
                              },
                              expression: "newSchemeName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        [
                          _vm.displayAddEditManyWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addLastLimitRate(false)
                                    },
                                  },
                                },
                                [_vm._v("确认添加新方案")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayAddEditManyWeight
                    ? _c(
                        "el-form-item",
                        [
                          _vm.displayAddEditManyWeight
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.cancelAddLastLimitRate },
                                },
                                [_vm._v("取消添加方案")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c("p", [_vm._v("可用通道")]),
              _c(
                "draggable",
                {
                  attrs: { group: _vm.grouptableA, clone: _vm.clone },
                  on: { end: _vm.groupLimitRateEnd },
                  model: {
                    value: _vm.notManyWeight,
                    callback: function ($$v) {
                      _vm.notManyWeight = $$v
                    },
                    expression: "notManyWeight",
                  },
                },
                _vm._l(_vm.notManyWeight, function (item, index) {
                  return _c(
                    "el-tag",
                    { key: index, staticClass: "channlName channl" },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bolder",
                            color: "#0059f6",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(item.method + ": " + item.channelStr)
                          ),
                        ]
                      ),
                      _vm._v(" " + _vm._s(" " + item.payKey) + " "),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.yesManyWeight, function (item, index) {
            return _c(
              "el-form",
              { key: index, attrs: { inline: true } },
              [
                index !== 0
                  ? _c("div", [_vm._v("---------------------")])
                  : _vm._e(),
                _c(
                  "draggable",
                  {
                    staticStyle: { "min-width": "100px" },
                    attrs: { group: _vm.groupA, options: { handle: ".dd" } },
                    model: {
                      value: item.channels,
                      callback: function ($$v) {
                        _vm.$set(item, "channels", $$v)
                      },
                      expression: "item.channels",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "区间内最小权重" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.payOutLimitStart,
                            callback: function ($$v) {
                              _vm.$set(item, "payOutLimitStart", _vm._n($$v))
                            },
                            expression: "item.payOutLimitStart",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "区间内最大权重" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.payOutLimitEnd,
                            callback: function ($$v) {
                              _vm.$set(item, "payOutLimitEnd", _vm._n($$v))
                            },
                            expression: "item.payOutLimitEnd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道：" } },
                      _vm._l(item.channels, function (item1, index1) {
                        return _c(
                          "div",
                          { key: index1, staticClass: "channlName channl" },
                          [
                            _c(
                              "el-tag",
                              {
                                key: index1,
                                attrs: { closable: "" },
                                on: {
                                  close: function ($event) {
                                    return _vm.deleteLimitChannl(index, index1)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "bolder",
                                      color: "#0059f6",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item1.method + ": " + item1.channelStr
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " + _vm._s(" " + item1.payKey) + " 权重: "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "50px" },
                                  attrs: { size: "mini" },
                                  model: {
                                    value: item1.payOutLimitWeight,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item1,
                                        "payOutLimitWeight",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "item1.payOutLimitWeight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "删除" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            size: "mini",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteLimitRate(item, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c("el-button", {
            attrs: { type: "primary", icon: "el-icon-plus", size: "mini" },
            on: {
              click: function ($event) {
                return _vm.addLimitRate()
              },
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.manyWeightVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              !_vm.displayAddEditManyWeight
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.editManyWeightBotton,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addLastLimitRate(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.manyWeightDialog ? "应用此方案" : "确 定")
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加可用通道", visible: _vm.availableChannlVisble },
          on: {
            "update:visible": function ($event) {
              _vm.availableChannlVisble = $event
            },
            close: _vm.clearAvailableChannl,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择通道" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.selectAddChannl,
                      props: {
                        value: "select",
                        label: "ID",
                        lazy: true,
                        lazyLoad: _vm.dynamicallyLoadingData,
                      },
                    },
                    model: {
                      value: _vm.addOneChannel,
                      callback: function ($$v) {
                        _vm.addOneChannel = $$v
                      },
                      expression: "addOneChannel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "输入最大代收金额" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.maxCash,
                      callback: function ($$v) {
                        _vm.maxCash = _vm._n($$v)
                      },
                      expression: "maxCash",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.availableChannlVisble = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addAvailableChannl },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "商户多权重", visible: _vm.merchantWeightDialog },
          on: {
            "update:visible": function ($event) {
              _vm.merchantWeightDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("p", [_vm._v("可用通道")]),
              _c(
                "draggable",
                {
                  attrs: { group: _vm.grouptableA, clone: _vm.clone },
                  on: { end: _vm.groupMerchantEnd },
                  model: {
                    value: _vm.notManyWeight,
                    callback: function ($$v) {
                      _vm.notManyWeight = $$v
                    },
                    expression: "notManyWeight",
                  },
                },
                _vm._l(_vm.notManyWeight, function (item, index) {
                  return _c(
                    "el-tag",
                    { key: index, staticClass: "channlName channl" },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bolder",
                            color: "#0059f6",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(item.method + ": " + item.channelStr)
                          ),
                        ]
                      ),
                      _vm._v(" " + _vm._s(" " + item.payKey) + " "),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.yesMerchantWeight, function (item, index) {
            return _c(
              "el-form",
              { key: index, attrs: { inline: true } },
              [
                index !== 0
                  ? _c("div", [_vm._v("---------------------")])
                  : _vm._e(),
                _c(
                  "draggable",
                  {
                    staticStyle: { "min-width": "100px" },
                    attrs: { group: _vm.groupA, options: { handle: ".dd" } },
                    model: {
                      value: item.channels,
                      callback: function ($$v) {
                        _vm.$set(item, "channels", $$v)
                      },
                      expression: "item.channels",
                    },
                  },
                  [
                    item.MerchantID
                      ? _c("span", [_vm._v("商户: " + _vm._s(item.MerchantID))])
                      : _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择商户" },
                            model: {
                              value: item.MerchantID,
                              callback: function ($$v) {
                                _vm.$set(item, "MerchantID", $$v)
                              },
                              expression: "item.MerchantID",
                            },
                          },
                          _vm._l(_vm.merchantIdList, function (itme1) {
                            return _c("el-option", { attrs: { value: itme1 } })
                          }),
                          1
                        ),
                    _c("br"),
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道：" } },
                      _vm._l(item.channels, function (item1, index1) {
                        return _c(
                          "div",
                          { key: index1, staticClass: "channlName channl" },
                          [
                            _c(
                              "el-tag",
                              {
                                key: index1,
                                attrs: { closable: "" },
                                on: {
                                  close: function ($event) {
                                    return _vm.deleteMerchantWightChannl(
                                      index,
                                      index1
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "bolder",
                                      color: "#0059f6",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item1.method + ": " + item1.channelStr
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " + _vm._s(" " + item1.payKey) + " 权重: "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "50px" },
                                  attrs: { size: "mini" },
                                  model: {
                                    value: item1.weight,
                                    callback: function ($$v) {
                                      _vm.$set(item1, "weight", _vm._n($$v))
                                    },
                                    expression: "item1.weight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "删除" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            size: "mini",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteMerchantWight(item, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c("el-button", {
            attrs: { type: "primary", icon: "el-icon-plus", size: "mini" },
            on: {
              click: function ($event) {
                return _vm.addMerchantWight()
              },
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.manyWeightVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              !_vm.displayAddEditManyWeight
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.editManyWeightBotton,
                      },
                      on: { click: _vm.addMerchantWightConfim },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.manyWeightDialog ? "应用此方案" : "确 定")
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }